import React, { useEffect } from 'react'
import {Link} from 'react-router-dom'
function Cancel() {
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
  <>
  <div className='container-fluid'>

<div className='row d-flex justify-content-center pt-3'>
          <div className='col-md-6'>
            <h1 className='h1 text-center'>Cancellation/Refund Policy</h1>
          </div>
        </div>

    <div className='row d-flex justify-content-center pt-1 mb-5'>

     
        <div className='col-md-10 shadow-xl'>
        <hr className="custom-hr bg-gradient-to-r from-sky-800 to-sky-700" style={{height:"7px", border:"none"}}/>  
            <div className='row p-2 text-justify'>
     <p>There will be no Cancellation/Refund policy with us as of now.</p>

<p>We reserve the right to update or modify Cancellation/Refund Policy at any time. Users will be notified of any significant changes, and continued use of the platform after changes are posted will constitute acceptance of the revised Terms.</p>


<p>If you have any questions regarding this policy.</p>

      
        <div className='row p-4 d-flex justify-content-center'>
        <div className='col-md-9 shadow-xl rounded-lg text-center'> 
        <p className="fw-bold">And as always, if you have questions about these changes, feel free to email us at <a href="mailto:info@sankhyana.com">info@sankhyana.com</a>.</p>
        <Link to="/contact"><button className='btn border-animation mt-2'>Contact Us</button></Link>
        </div>
      </div>


            </div>
        </div>

       

    </div>
</div>
  </>
  )
}

export default Cancel


